export const SferumIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none">
      <path
        fill="#7DFAE3"
        d="M16.104 16.103c4.646-4.646 6.53-10.295 4.206-12.618-2.323-2.323-7.972-.44-12.619 4.206-4.646 4.646-6.529 10.296-4.206 12.619 2.323 2.323 7.973.44 12.619-4.207Z"
      />
      <path
        fill="url(#a)"
        d="M3.485 3.484c-4.647 4.647-4.647 12.18 0 16.825-2.295-2.294-.488-7.833 4.036-12.445.055-.059.113-.116.17-.173.057-.058.114-.115.173-.17 4.611-4.522 10.152-6.33 12.446-4.037-4.647-4.646-12.18-4.645-16.825 0Z"
      />
      <path
        fill="url(#b)"
        d="M7.69 24.515c4.647 4.647 12.18 4.647 16.825 0 4.646-4.645 4.647-12.178 0-16.825-.49-.491-1.131-.795-1.88-.922a5.529 5.529 0 0 0-1.35-.054c-2.711.196-6.276 2.07-9.388 5.183-3.114 3.113-4.986 6.677-5.183 9.389-.036.48-.018.931.054 1.348.127.75.431 1.39.922 1.881Z"
      />
      <defs>
        <linearGradient id="a" x1="6.65" x2="22.225" y1="22.509" y2="6.934" gradientUnits="userSpaceOnUse">
          <stop stop-color="#3549FF" />
          <stop offset=".508" stop-color="#8742EE" />
          <stop offset="1" stop-color="#DD42EE" />
        </linearGradient>
        <linearGradient id="b" x1="6.65" x2="22.225" y1="22.509" y2="6.934" gradientUnits="userSpaceOnUse">
          <stop stop-color="#3549FF" />
          <stop offset=".508" stop-color="#8742EE" />
          <stop offset="1" stop-color="#DD42EE" />
        </linearGradient>
      </defs>
    </svg>
  );
};
